<template>
	<div class="message-list" :class="[isCanClick?'cursor':'']" @click="toDetail(item)">
		<div class="message-user" v-if="isShowHeadPic">
			<img :src="item.headPic?item.headPic:'../../assets/default_avatar.png'" />
			<span>{{item.addUserName}}</span>
		</div>
		<div class="message-title-wrap">
			<span class="stick" v-if="item.top==1">置顶</span>
			<div class="message-title">{{item.title}}</div>
		</div>
		<div class="reply-data" v-if="item.replyData">
			<div class="reply-data-user">{{item.replyData.addUserName}} 发表于 {{item.replyData.addTime | datefmt('YYYY-MM-DD hh:mm:ss')}}</div>
			<div v-html="item.replyData.content"></div>
		</div>
		<div class="message-txt" :class="[isCutLine?'line2':'']" v-html="item.content"></div>
		<div v-if="isCutLine" class="message-more">查看详情 ></div>
		<div class="message-tips">
			<div class="message-tips-l">
				<span>{{item.addTime | datefmt('YYYY-MM-DD')}}</span>
				<div class="replay-num" v-if="isShowReplyNum">
					<img src="../../assets/replay_icon.png" />
					<span>{{item.replyNum}}</span>
				</div>
			</div>
			<div class="message-tips-r">
				<span class="replay-btn" v-if="isShowHeadPic" @click.stop="toReply(item)">回 复</span>
				<span class="audit-status" v-if="isMessageMy&&item.auditStatus==0">未审核</span>
				<span class="audit-status green" v-if="isMessageMy&&item.auditStatus==1">审核通过</span>
				<span class="audit-status" v-if="isMessageMy&&item.auditStatus==2">未通过审核</span>
				<span class="audit-status" @click.stop="toDelete(item)" v-if="isMessageMy">删除</span>
			</div>
		</div>
		<div class="audit-comment" v-if="item.auditComment&&item.auditComment.length>0&&item.auditStatus==2">
			<p>未通过审核原因：</p>
			<p>{{item.auditComment}}</p>
		</div>
		<div class="message-reply-wrap" v-if="item.replyList&&item.replyList.length>0">
			<div class="message-reply" v-for="itemReply in item.replyList" v-html="itemReply.content" :key="itemReply.id"></div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'messageItem',
		props: {
			item: { //传递过来的数据模型
				type: Object
			},
			isShowHeadPic: {  //是否显示头像信息
				type: Boolean,
				default: true
			},
			isCutLine: {  //是否截取显示2行
				type: Boolean,
				default: true
			},
			isCanClick: {   //是否可点击跳转
				type: Boolean,
				default: true
			},
			isShowReplyNum: {   //是否显示回复数量
				type: Boolean,
				default: true
			},
			isMessageMy: {
				type: Boolean,
				default: false
			}
		},
		data(){
			return{
				
			}
		},
		methods: {
			toReply(item){
				this.$emit('toReply', {
					id: item.id,
					title: item.title
				})
			},
			toDetail(item){
				if(this.isCanClick){
					this.$router.push({
						path: '/messageBoard/messageDetail',
						query: {
							id: item.id
						}
					})
					this.$emit('toDetail')
				} else {
					return
				}
				
			},
			toDelete(item){
				this.$emit('toDelete', {
					id: item.id
				})
			}
		},
		created(){
			
		}
	}
</script>

<style scoped lang="less">
	.message-list{
		border-bottom: 3px solid #f7f7f7;
		padding: 20px;
		box-sizing: border-box;
		.message-user{
			display: flex;
			align-items: center;
			img{
				width: 26px;
				height: 26px;
				margin-right: 10px;
				border-radius: 50%;
			}
		}
		.message-title-wrap{
			display: flex;
			align-items: center;
			margin-left: 36px;
			font-weight: bold;
			font-size: 15px;
			.stick{
				box-sizing: border-box;
				border: 1px solid #DE0515;
				padding: 0 4px;
				border-radius: 4px;
				margin-right: 10px;
				font-size: 12px;
				font-weight: normal;
				line-height: 18px;
			}
			.message-title{
				flex: 1;
				word-break: break-all;
				word-wrap: break-word;
			}
		}
		.message-txt{
			margin: 10px 0 10px 36px;
			line-height: 28px;
		}
		.replay-num{
			display: flex;
			align-items: center;
			margin-left: 60px;
			img{
				width: 15px;
				height: 15px;
				margin-right: 5px;
			}
		}
		.line2{
			text-overflow: -o-ellipsis-lastline;  
			overflow: hidden;  
			text-overflow: ellipsis;  
			display: -webkit-box;  
			-webkit-line-clamp: 2;  
			-webkit-box-orient: vertical;  
		}
		.message-more{
			display: flex;
			justify-content: flex-end;
			margin: 10px 0;
			color: #DE0515;
			font-size: 12px;
		}
		.message-tips{
			display: flex;
			justify-content: space-between;
			margin-left: 36px;
			font-size: 12px;
			.message-tips-l{
				display: flex;
				color: #929292;
				align-items: center;
			}
			.replay-btn{
				width: 102px;
				height: 34;
				background: #F4F4F4;
				display: block;
				line-height: 34px;
				text-align: center;
				cursor: pointer;
				font-size: 16px;
			}
			.replay-btn:hover{
				background: #DE0515;
				color: #fff;
			}
			.audit-status{
				display: inline-block;
				padding:0 10px; height: 22px; margin: 16px 10px 0; background: #BFBDBD;
				border-radius: 5px; font-size: 13px; line-height: 22px; text-align:center; color:#fff
			}
			.green{
				background: #56D546
			}
		}
		.message-reply-wrap{
			padding-top: 15px;
			color: #B2B2B2;
			font-size: 12px;
			.message-reply{
				margin-bottom: 15px;
			}
		}
		.reply-data{
			margin-top: 10px;
			margin-left: 36px;
			background: #F9F9F9;
			padding: 10px 20px;
			font-size: 12px;
			color: #999
		}
	}
	.audit-comment{
		margin-top: 10px;
		font-size: 12px;
	}
	.audit-comment p:nth-of-type(1){
		color: #DE0515;
	}
	.cursor{
		cursor: pointer;
	}
</style>
